/* Records On Records — v11 JS */
(function () {
  'use strict';

  /* ── Utilities ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Toast ── */
  let toastTimer;
  function showToast(msg, type) {
    let t = qs('.ror-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ror-toast';
      t.innerHTML = '<span class="toast-icon"></span><span class="toast-msg"></span>';
      document.body.appendChild(t);
    }
    clearTimeout(toastTimer);
    t.className = 'ror-toast ' + (type || 'success');
    t.querySelector('.toast-icon').textContent = type === 'error' ? '✕' : '✓';
    t.querySelector('.toast-msg').textContent = msg;
    requestAnimationFrame(() => { requestAnimationFrame(() => { t.classList.add('show'); }); });
    toastTimer = setTimeout(() => { t.classList.remove('show'); }, 3000);
  }

  /* ── Header scroll state ── */
  const header = qs('[data-site-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
    const menuBtn = qs('[data-menu-button]');
    if (menuBtn) {
      menuBtn.addEventListener('click', function () {
        const open = header.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ── Search overlay ── */
  const searchOverlay = qs('.search-overlay');
  if (searchOverlay) {
    qsa('[data-search-open]').forEach(btn => {
      btn.addEventListener('click', () => {
        searchOverlay.classList.add('open');
        const inp = qs('input[type="search"]', searchOverlay) || qs('input', searchOverlay);
        if (inp) setTimeout(() => inp.focus(), 80);
      });
    });
    qs('.search-close', searchOverlay)?.addEventListener('click', () => searchOverlay.classList.remove('open'));
    searchOverlay.addEventListener('click', e => { if (e.target === searchOverlay) searchOverlay.classList.remove('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') searchOverlay.classList.remove('open'); });
  }

  /* ── Cart Drawer ── */
  const cartOverlay = qs('.cart-drawer-overlay');
  const cartDrawer = qs('.cart-drawer');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  qs('.cart-drawer__close')?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  qsa('[data-cart-open]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); openCart(); }));

  function buildCartLine(item) {
    const imgSrc = item.featured_image?.url
      ? item.featured_image.url.replace(/(\.\w+)$/, '_160x160$1')
      : null;
    const imgHtml = imgSrc
      ? `<img src="${imgSrc}" alt="${item.product_title}" loading="lazy">`
      : `<div class="placeholder-disc" aria-hidden="true"></div>`;
    const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="cart-line__variant">${item.variant_title}</div>` : '';
    return `
      <div class="cart-line" data-key="${item.key}">
        <div class="cart-line__img">${imgHtml}</div>
        <div class="cart-line__info">
          <div class="cart-line__vendor">${item.vendor || ''}</div>
          <div class="cart-line__title">${item.product_title}</div>
          ${variantHtml}
          <div class="cart-line__qty">
            <button type="button" class="qty-dec" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" class="qty-inc" aria-label="Increase quantity">+</button>
            <button type="button" class="cart-line__remove">Remove</button>
          </div>
        </div>
        <div class="cart-line__price">${money(item.final_line_price)}</div>
      </div>`;
  }

  async function refreshCartDrawer() {
    if (!cartDrawer) return;
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      const body = qs('.cart-drawer__body', cartDrawer);
      const subtotalEl = qs('.cart-drawer__subtotal-value', cartDrawer);
      const checkoutForm = qs('#CartDrawerCheckoutForm', cartDrawer);
      const checkoutBtn = qs('.cart-drawer__checkout', cartDrawer);
      updateCartCount(cart.item_count);
      if (cart.item_count === 0) {
        body.innerHTML = `<div class="cart-drawer__empty">Your cart is empty.<br><a href="/collections/latest-vinyl-drops">Shop latest drop →</a></div>`;
        if (subtotalEl) subtotalEl.textContent = '$0.00';
        if (checkoutBtn) { checkoutBtn.disabled = true; checkoutBtn.style.opacity = '.45'; }
      } else {
        body.innerHTML = cart.items.map(buildCartLine).join('');
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
        if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.style.opacity = ''; }
        // Qty controls
        qsa('.qty-dec, .qty-inc', body).forEach(btn => {
          btn.addEventListener('click', async function () {
            const line = this.closest('.cart-line');
            const key = line.dataset.key;
            const qtySpan = qs('span', qs('.cart-line__qty', line));
            const current = parseInt(qtySpan.textContent, 10);
            const newQty = this.classList.contains('qty-dec') ? Math.max(0, current - 1) : current + 1;
            await updateCartLine(key, newQty);
          });
        });
        qsa('.cart-line__remove', body).forEach(btn => {
          btn.addEventListener('click', async function () {
            const line = this.closest('.cart-line');
            await updateCartLine(line.dataset.key, 0);
          });
        });
      }
    } catch (e) { console.warn('Cart refresh failed', e); }
  }

  async function updateCartLine(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCartDrawer();
    } catch (e) { console.warn('Cart update failed', e); }
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.add('bump');
      setTimeout(() => el.classList.remove('bump'), 300);
    });
  }

  /* ── Quick Add + Featured Card Add ── */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.quick-add-form, .featured-card__form');
    if (!form) return;
    e.preventDefault();
    const btn = qs('button[type="submit"]', form);
    const orig = btn ? btn.textContent : '';
    try {
      if (btn) { btn.disabled = true; btn.classList.add('loading'); btn.textContent = '···'; }
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData });
      if (!res.ok) throw new Error('add failed');
      const item = await res.json();
      if (btn) { btn.classList.remove('loading'); btn.classList.add('success'); btn.textContent = '✓ Added'; }
      // Refresh count
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (cartRes.ok) { const c = await cartRes.json(); updateCartCount(c.item_count); }
      // Open drawer
      openCart();
      setTimeout(() => {
        if (btn) { btn.textContent = orig; btn.disabled = false; btn.classList.remove('success'); }
      }, 1800);
    } catch (err) {
      if (btn) { btn.classList.remove('loading'); btn.textContent = 'Try again'; btn.disabled = false; }
      showToast('Could not add to cart. Please try again.', 'error');
    }
  });

  /* ── Add to cart (product page full form) ── */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.product-form__submit');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;
    if (form.classList.contains('quick-add-form')) return; // handled above
    e.preventDefault();
    const orig = btn.textContent;
    try {
      btn.disabled = true; btn.classList.add('loading'); btn.textContent = 'Adding…';
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error('add failed');
      btn.classList.remove('loading'); btn.classList.add('success'); btn.textContent = '✓ Added to cart';
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (cartRes.ok) { const c = await cartRes.json(); updateCartCount(c.item_count); }
      openCart();
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; btn.classList.remove('success'); }, 2200);
    } catch (err) {
      btn.classList.remove('loading'); btn.textContent = orig; btn.disabled = false;
      showToast('Could not add to cart.', 'error');
    }
  });

  /* ── Product Gallery ── */
  const mainImg = qs('.product-gallery__main img');
  if (mainImg) {
    qsa('.product-gallery__thumb').forEach(thumb => {
      thumb.addEventListener('click', function () {
        const src = this.dataset.src;
        const srcset = this.dataset.srcset;
        if (mainImg && src) {
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
        }
        qsa('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  /* ── Collection sort select ── */
  const sortSelect = qs('.sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
    const currentSort = new URL(window.location.href).searchParams.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;
  }

  /* ── Policy Accordion ── */
  qsa('.policy-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const body = this.nextElementSibling;
      const isOpen = body?.classList.contains('open');
      // Close all
      qsa('.policy-accordion__body').forEach(b => b.classList.remove('open'));
      qsa('.policy-accordion__trigger').forEach(t => t.classList.remove('open'));
      if (!isOpen && body) { body.classList.add('open'); this.classList.add('open'); }
    });
  });

  /* ── Recently Viewed ── */
  const RV_KEY = 'ror_recently_viewed';
  const RV_MAX = 8;
  function getRV() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch { return []; } }
  function setRV(arr) { try { localStorage.setItem(RV_KEY, JSON.stringify(arr)); } catch {} }
  function trackRV(handle, title, price, image, url) {
    if (!handle) return;
    let items = getRV().filter(i => i.handle !== handle);
    items.unshift({ handle, title, price, image, url });
    if (items.length > RV_MAX) items = items.slice(0, RV_MAX);
    setRV(items);
  }
  function renderRV(currentHandle) {
    const container = qs('#recently-viewed-grid');
    if (!container) return;
    const items = getRV().filter(i => i.handle !== currentHandle);
    if (!items.length) return;
    const section = qs('#recently-viewed');
    if (section) section.classList.add('has-items');
    container.innerHTML = items.slice(0, 4).map(item => `
      <article class="product-card" role="listitem">
        <div class="product-card__media-wrap">
          <a class="product-card__media" href="${item.url}" aria-label="${item.title}">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : '<div class="record-placeholder"></div>'}
          </a>
        </div>
        <div class="product-card__body">
          <h3 class="product-card__title"><a href="${item.url}">${item.title}</a></h3>
          <div class="product-card__meta">
            <div class="price"><span class="price__regular">${item.price}</span></div>
          </div>
        </div>
      </article>`).join('');
  }
  // Track current product
  const productMeta = qs('[data-product-handle]');
  if (productMeta) {
    trackRV(
      productMeta.dataset.productHandle,
      productMeta.dataset.productTitle,
      productMeta.dataset.productPrice,
      productMeta.dataset.productImage,
      productMeta.dataset.productUrl
    );
    renderRV(productMeta.dataset.productHandle);
  }

  /* ── Variant price update ── */
  const variantSelect = qs('#ProductVariantSelect');
  if (variantSelect && window.ROR_VARIANTS) {
    variantSelect.addEventListener('change', function () {
      const v = window.ROR_VARIANTS.find(x => String(x.id) === this.value);
      if (!v) return;
      const priceEl = qs('[data-product-price]');
      const compareEl = qs('[data-product-compare-price]');
      const stockEl = qs('[data-product-stock]');
      const submitBtn = qs('.product-form__submit');
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.style.display = ''; }
        else compareEl.style.display = 'none';
      }
      if (stockEl) stockEl.textContent = v.available ? 'Available' : 'Sold out';
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      const hiddenId = qs('input[name="id"]', variantSelect.closest('form'));
      if (hiddenId) hiddenId.value = v.id;
    });
  }


  /* ── Mobile fixed-header spacing ── */
  const mobileHeaderWrapper = document.getElementById('shopify-section-header') ||
    document.querySelector(".shopify-section[id$='__header']");

  function syncMobileHeaderHeight() {
    if (!mobileHeaderWrapper) return;
    if (window.matchMedia('(max-width: 1100px)').matches) {
      const height = Math.ceil(mobileHeaderWrapper.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--ror-mobile-header-height', `${height}px`);
    } else {
      document.documentElement.style.removeProperty('--ror-mobile-header-height');
    }
  }

  syncMobileHeaderHeight();
  window.addEventListener('resize', syncMobileHeaderHeight, { passive: true });
  window.addEventListener('orientationchange', syncMobileHeaderHeight, { passive: true });
  if ('ResizeObserver' in window && mobileHeaderWrapper) {
    new ResizeObserver(syncMobileHeaderHeight).observe(mobileHeaderWrapper);
  }


})();
